import { Formik, FormikActions, FormikProps, FormikValues, InjectedFormikProps } from 'formik';
import React from 'react';

import CurrentStep from './CurrentStep';
import WizardNavigation from './WizardNavigation';

import { WizardProps, WizardState } from './Wizard.types';
import { setInitialTouched } from '../../../utils/formHelpers';

class Wizard extends React.Component<WizardProps, WizardState> {
  static Step = ({ children }: { children: any }) => children;

  constructor(props: WizardProps) {
    super(props);

    this.state = {
      step: 0,
      values: props.initialValues,
      waiting: false,
      prevValues: undefined,
      bag: undefined
    };
  }

  componentDidUpdate() {
    const { values, bag, waiting } = this.state;

    if (bag && !waiting) {
      this.nextStep(values);
      bag.setTouched({});
      bag.setSubmitting(false);
    }
  }

  nextStep = (values: FormikValues): void => {
    const { children } = this.props;
    const { step } = this.state;

    window.scrollTo(0, 0);

    this.setState({
      bag: undefined,
      step: Math.min(step + 1, children.length - 1),
      values
    });
  };

  previousStep = (): void => {
    const { step, values } = this.state;

    window.scrollTo(0, 0);

    this.setState({
      step: Math.max(step - 1, 0),
      values
    });
  };

  handleSubmit = (values: FormikValues, bag: FormikActions<FormikValues>): void => {
    const { children, onSubmit, validating, initialValues } = this.props;
    const { step } = this.state;
    const isLastStep = step === React.Children.count(children) - 1;

    if (isLastStep) {
      return onSubmit(values);
    } else {
      if (validating) {
        this.setState({
          bag: bag,
          prevValues: values,
          waiting: true
        });
      } else {
        this.nextStep(initialValues);
        const touched = setInitialTouched(initialValues);
        bag.setTouched(touched);
        bag.setSubmitting(false);
      }
    }
  };

  render(): JSX.Element {
    const {
      children,
      validation,
      isSubmitting,
      enableReinitialize,
      validating,
      buttonLabels,
      isInitialValid
    } = this.props;
    const { step, values } = this.state;
    const activeStep = React.Children.toArray(children)[step];
    const stepCount = React.Children.count(children);
    const isLastStep = step === React.Children.count(children) - 1;

    return (
      <React.Fragment>
        <CurrentStep step={step} stepCount={stepCount} />
        <Formik
          initialValues={values}
          enableReinitialize={enableReinitialize}
          validationSchema={validation['STEP_' + (step + 1)]}
          isInitialValid={isInitialValid}
          onSubmit={this.handleSubmit}
          render={({
            handleSubmit,
            isValid
          }: InjectedFormikProps<FormikProps<FormikValues>, FormikValues>): JSX.Element => (
            <form onSubmit={handleSubmit}>
              {activeStep}

              <WizardNavigation
                step={step}
                isValid={isValid}
                validating={validating}
                buttonLabels={buttonLabels}
                isLastStep={isLastStep}
                isSubmitting={isSubmitting}
                previousStep={this.previousStep}
              />
            </form>
          )}
        />
      </React.Fragment>
    );
  }
}

export { Wizard as default };
